import LexisNexisDeeplink from './LexisNexisDeeplink'

export default LexisNexisDeeplink
